import React from 'react';
import { X } from 'react-feather';
import styles from './UserProfile.module.css';

const UserProfile = ({ user, onClose }) => {
  return (
    <div className={styles.userProfileOverlay}>
      <div className={styles.userProfileContent}>
        <button className={styles.closeButton} onClick={onClose}>
          <X size={24} />
        </button>
        <h2>{user.name}'s Profile</h2>
        {/* Add more user profile details here */}
        <p>User ID: {user.id}</p>
        {/* You can add more details like user's photo, bio, etc. */}
      </div>
    </div>
  );
};

export default UserProfile;